import SLICK from 'config/slick.singleton';
import { USE_SEGMENT_AND_UPSCOPE } from 'config/use.conf';
import { refreshCognitoUserToken } from 'utils/cognito.util';
import dispatch from 'utils/core/dispatch.util';
import getState from 'utils/core/getState.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

const L = logger('refreshMainToken');

const refreshMainToken = L.wrap('()', async (options) => {
  try {
    const { companyId, salonId, companyName } = asObject(options);
    const id = salonId || companyId;

    const state = getState();
    const { user, userPool } = asObject(state.cognito);
    const { signInUserSession, username } = asObject(user);

    const refreshToken = signInUserSession.refreshToken.getToken();
    const credentials = await refreshCognitoUserToken({ userPool, userName: username, refreshToken, dispatch });

    L.debug('()', { credentials, refreshToken, state });

    if (SLICK.segmentAnalytics && (id || companyName)) {
      if (USE_SEGMENT_AND_UPSCOPE) {
        SLICK.segmentAnalytics.identify(username, { company: { id, name: companyName } });
      } else {
        L.info('()', 'Due to a flag, skipping on identifying with:', { id, companyName });
      }
    }
  } catch (e) {
    L.warn('()', e);
  }
});

SLICK.token = Object.assign(SLICK.token || {}, { refreshMainToken });

// noinspection JSUnusedGlobalSymbols
export default refreshMainToken;
